module.exports = __webpack_public_path__ + "static/media/p10.4560a2ec.png";